import type { AssetId, OutlookSpaceAssetId } from 'owa-timestream-types';
import { assertNever } from 'owa-assert';
import assetIdMap from './assetIdMap';
import isLocalAssetId from './isLocalAssetId';

/** Resolves the given client asset IDs to the server generated value. */
export default function resolveAssetId(assetId: AssetId): Promise<OutlookSpaceAssetId | null> {
    if (isLocalAssetId(assetId)) {
        const serverId = assetIdMap.get(assetId);
        if (!serverId) {
            assertNever(`client asset ID: ${assetId}` as never);
        }

        if (typeof serverId === 'string') {
            return Promise.resolve(serverId);
        }

        return serverId as Promise<OutlookSpaceAssetId | null>;
    }

    return Promise.resolve(assetId as OutlookSpaceAssetId);
}
